<!--<ara-side-nav class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>
-->
  <div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mobile-view">
    <ol class="breadcrumb bc-3"  >
      <li>
      <a [routerLink]="'/home'">Home</a>
      </li>
      <li>
        <a>Person On Board</a>
      </li>
      
    </ol>
    <div class="inner-wrapper">
      <div class="sub-wrapper">
        <h3 class="page-title obs-card-title">Pass Request Form</h3>
        <div class="section-wrapper right">
          <span class="mandatory-info">Fields marked with
            <span class="mandatory">*</span> are mandatory</span>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <div class="sub-section-wrapper">
            <span class="section-sub-title">Unit Name
              <span class="mandatory">*</span>
            </span>
            <p-tree [value]="unitTree" selectionMode="single" (onNodeSelect)="nodeSelected($event)"
              [(selection)]="selectedUnit"></p-tree>
          </div>
          
          <div class="clearfix"></div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <div class="sub-section-wrapper" [hidden]="isUnitEmployee">
            <span class="section-sub-title">Contract Number <span class="mandatory">*</span></span>          
              <p-dropdown [options]="contracts" placeholder="Select" [style]="{'width':'100%'}" [(ngModel)]="selectedContract"
              (onChange)="checkHolder($event)" >
              </p-dropdown>   
              <span class="error-msg-colour"
                  *ngIf="showContractValidation">Please select Contract Number </span> 
              <span class="error-msg-colour"
                  *ngIf="!isHasContractDetails">Contract Holder is not available for this contract. Please contact admin to update these details.  </span>    
          </div>
          
          <div class="sub-section-wrapper">
            <span class="section-sub-title">Location
              <span class="mandatory">*</span>
            </span>
            <p-dropdown [options]="location" placeholder="Select" [(ngModel)]="selectedLocation" #locationName='ngModel'
              [style]="{'width':'100%'}"></p-dropdown>

            <div *ngIf="isIncidentReportErrorMsg && !selectedLocation">
              <span class="error-msg-colour">{{ 'PERSON-ON-BOARD.KINDLY_SELECT_LOCATION' | translate }}</span>
            </div>
            <div *ngIf="(locationName.touched || locationName.dirty) && !selectedLocation">
              <span class="error-msg-colour"><b>{{ 'PERSON-ON-BOARD.KINDLY_SELECT_LOCATION' | translate }}</b></span>
            </div>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title">{{ 'PERSON-ON-BOARD.PASS_TYPE' | translate }}
              <span class="mandatory">*</span>
            </span>
            <div class="table-responsiveb">
              <table class="table table-bordered pass-table-detail">
                <tr *ngFor="let PassTypeColumnData of PassTypeDetails">
                  <td>
                    {{PassTypeColumnData.PassTypeName}}
                  </td>
                  <td>
                    <button pButton type="button" label="Add Members"
                      (click)="showDialog(PassTypeColumnData.PassTypeName, PassTypeColumnData.PassTypeId)"
                      class="p-button-primary"
                      [disabled]=" PassTypeColumnData.Disabled || !selectedUnit || !selectedLocation || (!isUnitEmployee && !selectedContract)"></button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="form-group">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top-10 margin-bottom-20">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th style="padding:10px;">{{ 'PERSON-ON-BOARD.REQUEST_NO.' | translate }}</th>
                      <th style="padding:10px;">Name</th>
                      <th style="padding:10px;">Pass Type</th>
                      <th style="padding:10px;">{{ 'PERSON-ON-BOARD.DATE_FROM' | translate }}</th>
                      <th style="padding:10px;">{{ 'PERSON-ON-BOARD.DATE_TO' | translate }}</th>
                    </tr>
                  </thead>
                  <tr *ngFor="let dataFromPassRequest of dataFromPassRequestForm; let i = index">
                    <td>{{i+1}}</td>
                    <td>{{dataFromPassRequest.FullName}}</td>
                    <td>{{dataFromPassRequest.PassTypeName}}</td>
                    <td>{{dataFromPassRequest.PassRequestFromDate | date: 'dd/MM/yyyy'}}</td>
                    <td>{{dataFromPassRequest.PassRequestToDate | date: 'dd/MM/yyyy'}}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="clearfix"></div>
        <footer *ngIf="dataFromPassRequestForm.length>0">
          <!-- <button type="button" class="btn btn-primary primary-btn button-draft" (click)="saveAsDraft()">
					  <i class="fa fa-envelope"></i>Save As Draft</button>	 -->
          <a class="btn btn-primary primary-btn button-submit" role="button" (click)="submitPasses()">
            <i class="fa fa-share-square"></i>submit</a>
        </footer>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
<ara-alerts [alertType]="alertType" [successDetails]="successDetails" [errorDetails]="errorDetails"
  (okClicked)="onYesClickedSuccess()" [confirmMessage]="confirmMessage" (yesClicked)="onYesClickedForConfirmation()"
  (noClicked)="onNoClickedForConfirmation()"></ara-alerts>
<p-dialog header="Pass Request Form" [(visible)]="closePopup" (onHide)="closePopUp()" [modal]="true">
  <ara-view-pass-request [LocationName]="LocationName" [CompanyName]="CompanyName"
    [passTypeRowNameValue]="passTypeRowNameValue" [passTypeRowIdValue]="passTypeRowIdValue" [CompanyId]="CompanyId"
    [LocationId]="LocationId" [ContractId]="ContractId" [ContractNumber]="ContractNumber">
  </ara-view-pass-request>
</p-dialog>
